// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query ProductProducers($filterBy: InputProductProducersQueryFilter)  {\nproductProducers(filterBy: $filterBy)  \n}\n"]);

function parse(value) {
  let value$1 = value.productProducers;
  return {
    productProducers: value$1.map(value => value)
  };
}

function serialize(value) {
  let value$1 = value.productProducers;
  let productProducers = value$1.map(value => value);
  return {
    productProducers: productProducers
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputProductProducersQueryFilter(inp) {
  let a = inp.shopIds;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputProductProducersQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputProductProducersQueryFilter(shopIds, param) {
  return {
    shopIds: shopIds
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductProducersQueryFilter: serializeInputObjectInputProductProducersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductProducersQueryFilter: makeInputObjectInputProductProducersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductProducersQueryFilter: serializeInputObjectInputProductProducersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductProducersQueryFilter: makeInputObjectInputProductProducersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function useProductProducersQueryFn(variables) {
  return AsyncResult.mapError(ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, variables)), param => {});
}

function CatalogProducerSelect(props) {
  let onChange = props.onChange;
  let __useProductProducersQuery = props.useProductProducersQuery;
  let value = props.value;
  let shopId = props.shopId;
  let useProductProducersQuery = __useProductProducersQuery !== undefined ? __useProductProducersQuery : useProductProducersQueryFn;
  let queryResult = useProductProducersQuery({
    filterBy: {
      shopIds: shopId !== undefined ? ({
          _in: [shopId]
        }) : undefined
    }
  });
  let producers;
  if (typeof queryResult !== "object") {
    producers = queryResult === "NotAsked" ? [] : [];
  } else if (queryResult.TAG === "Reloading") {
    let match = queryResult._0;
    producers = match.TAG === "Ok" ? match._0.productProducers : [];
  } else {
    let match$1 = queryResult._0;
    producers = match$1.TAG === "Ok" ? match$1._0.productProducers : [];
  }
  let items = producers.map(producer => ({
    TAG: "Option",
    key: producer,
    label: producer,
    value: producer
  }));
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "__all__",
    label: defaultItem_1,
    value: undefined,
    exclusive: defaultItem_4
  };
  let sections = [
    {
      items: [defaultItem]
    },
    {
      items: items,
      title: I18n.t("Producers")
    }
  ];
  let onSelectionChange = selection => {
    if (selection.TAG === "Single") {
      return onChange(selection._0);
    }
  };
  let disabled = Stdlib_Option.isNone(shopId);
  let loading = AsyncResult.isBusy(queryResult);
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Select.make, {
      label: I18n.t("Producer"),
      placeholder: I18n.t("Select a producer"),
      preset: "filter",
      size: "compact",
      highlighted: Stdlib_Option.isSome(value),
      disabled: disabled,
      loading: loading,
      sections: sections,
      value: {
        TAG: "Single",
        _0: value
      },
      onChange: onSelectionChange
    }),
    placement: "top",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Please select a shop beforehand.")
    }),
    disabled: !disabled,
    delay: 350
  });
}

let make = CatalogProducerSelect;

export {
  Query,
  useProductProducersQueryFn,
  make,
}
/* query Not a pure module */
